import { render } from "./tests-desc.vue?vue&type=template&id=0b436b1e&scoped=true"
import script from "./tests-desc.vue?vue&type=script&lang=js"
export * from "./tests-desc.vue?vue&type=script&lang=js"

import "./tests-desc.vue?vue&type=style&index=0&id=0b436b1e&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b436b1e"]])

export default __exports__